<div *ngIf="loading">
    <h6>Please wait...</h6>
</div>

<div *ngIf="!loading" class="mx-3">

    <div class="document-line line mt-6"></div>


    <div class="mt-n5">
        <ul ngbNav #nav="ngbNav" [(activeId)]="active"
            class="nav-tabs profile-page-bar text-dark text-center bg-transparent d-flex justify-content-between">
            <li (click)="changeCategory('generalDocs')" [ngbNavItem]="1">
                <a class="link text-dark" ngbNavLink>
                    <span><i class="bi bi-person fs-3 text-light"
                            [ngClass]="{'fs-2 box-shadow-custom': +active === 1, 'fs-3': +active !== 1}"></i>
                    </span>
                    <br> <br>
                    <span class="nav-text"><b>General Docs</b></span><span class="text-danger">*</span>
                </a>
                <ng-template ngbNavContent>
                    <div class="mb-4">
                        <fa-admission-document-upload (emitDocumentData)="updateDocumentUpload($event)"
                            *ngIf="uploadFormData" [data]="uploadFormData"
                            (documentUploaded)="getUpdatedDocumentsCount($event)"></fa-admission-document-upload>
                    </div>
                </ng-template>
            </li>



            <li 
                (click)="changeCategory('uploadedByFA')" [ngbNavItem]="2">
                <a class="link text-dark" ngbNavLink>
                    <span> <i class="bi bi-mortarboard fs-3 text-light"
                            [ngClass]="{'fs-2 box-shadow-custom': +active === 2, 'fs-3': +active !== 2}"></i> </span>
                    <br> <br>
                    <span class="nav-text"><b>Uploaded by Applications Team</b></span>
                </a>
                <ng-template ngbNavContent>
                    <div class="mb-4">
                        <fa-admission-document-upload (documentUploaded)="updateDocumentUpload($event)"
                            *ngIf="uploadFormData" [data]="uploadFormData"></fa-admission-document-upload>
                    </div>

                </ng-template>
            </li>

            <li 
                (click)="changeCategory('additionalRequests')" [ngbNavItem]="3">
                <a class="link text-dark" ngbNavLink>
                    <span> <i class="bi bi-award fs-3 text-light"
                            [ngClass]="{'fs-2 box-shadow-custom': +active === 3, 'fs-3': +active !== 3}"></i> </span>
                    <br> <br>
                    <span class="nav-text"><b>Additional Requests</b></span>
                </a>
                <ng-template ngbNavContent>
                    <div class="mb-4">
                        <fa-admission-document-upload (documentUploaded)="updateDocumentUpload($event)"
                            *ngIf="uploadFormData" [data]="uploadFormData"></fa-admission-document-upload>
                    </div>
                </ng-template>
            </li>

        </ul>

    </div>

    <div [ngbNavOutlet]="nav" class="nav-outlet"></div>

</div>